export default __webpack_public_path__ + "static/media/btn_ChevronRight.88e10bfb.svg";